import styled from 'styled-components';
import shadowBig from '../../assets/images/shadow.png';

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background: #111314;
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledShadowBig = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 2000px;
	height: 2000px;
	background-image: url(${shadowBig});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export { StyledContainer, StyledShadowBig };
